import { render, staticRenderFns } from "./UserDataModal.vue?vue&type=template&id=2aec1af3&scoped=true&"
import script from "./UserDataModal.vue?vue&type=script&lang=js&"
export * from "./UserDataModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDataModal.vue?vue&type=style&index=0&id=2aec1af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec1af3",
  null
  
)

export default component.exports